import classes from './Spinner.module.scss';

const spinner = props => (
	<div className={classes.Loader} {...props}>
		Loading...
	</div>
);

export default spinner;
